/** Packages **/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OpenTimeSearchHead from './OpenTimeSearchHead';
import { openTimeSearch } from '../../data/constants';
import Loader from './../../components/Loader';
import './styles.scss';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../context/LanguageContext';

export const ArrowBackIosIconCust = withStyles({
  root: {
    marginTop: '8px',
    marginLeft: '8px'
  },
})(ArrowBackIosIcon);

export const ArrowForwardIosIconCust = withStyles({
  root: {
    marginTop: '8px',
  },
})(ArrowForwardIosIcon);
class OpenTimeSearchTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      maxResults: this.props.filter.maxResults,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { firstResult, maxResults } = nextProps.filter;
    const activePage = (firstResult / maxResults) + 1;

    this.setState({ maxResults, activePage });
  }
  handleSortCriteria = (criteria, direction) => {
    this.props.handleSort(criteria, direction);
  }
  handleScroll = (e) => {
    document.getElementById('Calendar-Wrapper').scrollLeft = e.nativeEvent.target.scrollLeft;
  }
  getNumberOptions = (count, multiple, defaultValue) => {
    const options = (defaultValue > multiple) ? [] : [<MenuItem key={defaultValue} value={defaultValue}>{defaultValue}</MenuItem>];
    for (let i = 1; i <= count; i += 1) {
      options.push(<MenuItem key={i * multiple} value={i * multiple}>{i * multiple}</MenuItem>);
    }
    return options;
  }
  handleChangePage = (activePage) => {
    const maxResults = this.state.maxResults;
    const firstResult = maxResults * (activePage - 1);

    this.props.handlePagination(maxResults, firstResult);
  }
  handleChangeSelect = (event, index, value) => {
    /*
      After user change the maxResults, reset the pagination and go to page 1.
    */
    this.setState(
      { maxResults: event.target.value },
      () => this.handleChangePage(1)
    );
  }
  render() {
    const openTimeSearchLabels = this.props.labels?.openTimeSearchLabels || {};
    const message = (!this.props.fetchFromFilter) ?
      openTimeSearchLabels.NO_ACTIVITIES : openTimeSearchLabels.NO_ACTIVITIES_FETCHED;
    const activities = (this.props.activities.length !== 0) ?
      this.props.activities : (<p className="no-activities-message">{message}</p>);
    const { totalEntries, isFetching } = this.props;

    const showingFrom = this.props.filter.firstResult + 1;
    let showingTo = this.props.filter.maxResults * this.state.activePage;
    showingTo = (totalEntries < showingTo) ? totalEntries : showingTo;

    return (
      <div className="Open-Time-Wrapper">
        <div onScroll={this.handleScroll} id="Open-Time-Helper" className="Open-Time-Helper">
          <div className="Open-Time-Search" style={{ minWidth: this.props.minContainerWidth }}>
            <OpenTimeSearchHead
              handleSort={this.handleSortCriteria}
              handleRefresh={this.props.handleRefresh}
              activityType={openTimeSearchLabels.table?.ACTIVITY_TYPE}
              name={openTimeSearchLabels.table?.NAME}
              startDate={openTimeSearchLabels.table?.START_DATE}
              endDate={openTimeSearchLabels.table?.END_DATE}
              credit={openTimeSearchLabels.table?.CREDIT}
              ranking={openTimeSearchLabels.table?.ANALYZER_RANK}
              layover={openTimeSearchLabels.table?.LAYOVER}
              deadhead={'DH'}
              sortCriteria={this.props.filter.sortCriteria}
              sortDirection={this.props.filter.sortDirection}
              isFetchingBidAnalyzer={this.props.isFetchingBidAnalyzer}
              fromAddButton={this.props.fromAddButton}
              setFromAddButton={this.props.setFromAddButton}
            />
            { !isFetching && activities }
          </div>
          { isFetching && <Loader className={'openTimeSearch-loader'} /> }
        </div>
        <div className="pagination-container">
          {(this.props.activities.length !== 0 && totalEntries > openTimeSearch.MINIMUM_ITEMS) ?
            <div className="rowMax-selector">
              <div className="items-per-page-container">
                <span>{openTimeSearchLabels.ACTS_PER_PAGE}</span>
                <FormControl variant="outlined">
                  <Select
                    className="selectField"
                    value={this.state.maxResults}
                    onChange={this.handleChangeSelect}
                  >
                    {this.getNumberOptions(openTimeSearch.TOTAL_OPTIONS, openTimeSearch.OPTIONS_MULTIPLE, openTimeSearch.MINIMUM_ITEMS)}
                  </Select>
                </FormControl>
              </div>
              {totalEntries >= this.state.maxResults &&
              <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.maxResults}
                totalItemsCount={totalEntries}
                pageRangeDisplayed={5}
                onChange={this.handleChangePage}
                prevPageText={<ArrowBackIosIconCust fontSize="small"/>}
                nextPageText={<ArrowForwardIosIconCust fontSize="small"/>}
              />
              }
            </div> : ''}
        </div>
        <div className="index-container">
          {(this.props.activities.length !== 0) ?
            `${showingFrom} — ${showingTo} of ${totalEntries}` : ''
          }
        </div>
      </div>
    );
  }
}

OpenTimeSearchTable.propTypes = {
  activities: PropTypes.array.isRequired,
  totalEntries: PropTypes.number.isRequired,
  handlePagination: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired,
  fetchFromFilter: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isFetchingBidAnalyzer: PropTypes.bool.isRequired,
  filter: PropTypes.object.isRequired,
  minContainerWidth: PropTypes.number.isRequired,
};

OpenTimeSearchTable.defaultProps = {
  totalEntries: 0,
};

function OpenTimeSearchTableWrapper(props) {
  const { labels } = useLanguage();
  return <OpenTimeSearchTable {...props} labels={labels} />;
}

export default OpenTimeSearchTableWrapper;
